import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const OlympiadManagement = () => {
    return (
        <Box>
            <Paper sx={{ p: 3 }}>
                <Typography variant="h5" fontWeight={600} gutterBottom>
                    Olympiad Management
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    This module is under development. It will help manage various olympiad competitions and registrations.
                </Typography>
            </Paper>
        </Box>
    );
};

export default OlympiadManagement;

